export default __webpack_public_path__ + "static/media/work5.9a1f2161.png";